import config from "../config";
import {sendGetRequest} from "../Utility/FetchUtils";

class WindowsServiceApi{
    static BASE_URL = config.SERVICE_URL + "/WindowsService";

    static restartService(){
        const url = WindowsServiceApi.BASE_URL + "/:restart-service";
        return sendGetRequest(url);
    }
}

export default WindowsServiceApi;